jQuery(function($) {
  $('.load-more-posts').on('click', function() {

    var $button = $(this),
      data = {
        'action': 'loadmoreposts',
        'page': faoLoadMoreSettings.currentPage,
        'postType': faoLoadMoreSettings.postType
      };

    $button.parent().addClass('loading');


    $.ajax({
      url: faoLoadMoreSettings.url, // AJAX handler
      data: data,
      type: 'POST',
      beforeSend: function(){
      },
      complete: function(){
        $button.parent().removeClass('loading');
      },
      success: function(data) {
        $button.blur();
        if (data) {
          var $ajaxAppendedPosts = $(data.posts.join(''));
          $button.parent().before($ajaxAppendedPosts);
          $ajaxAppendedPosts.addClass('loaded');
          
          $($ajaxAppendedPosts.get(0)).find('.read-more a').focus();
          setTimeout(function() {
            $ajaxAppendedPosts.addClass('appended');
          }, 1);

          faoLoadMoreSettings.currentPage++;

          if (faoLoadMoreSettings.currentPage === faoLoadMoreSettings.maxPage) {
            $button.remove();
          }
        }
      }
    });
  });
});
